const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M88.002 48.774V20.185c-40.576 15.86-55.411 27.966-51.375 66.149.199 1.889 1.324 3.585 3.047 4.384 3.204 1.484 6.094 2.3 8.328 2.3 11.429 0 40-21.347 40-44.244",
    style: {
      fill: "url(#a)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.002 48.774V20.185c-40.576 15.86-55.411 27.966-51.375 66.149.199 1.889 1.324 3.585 3.047 4.384 3.204 1.484 6.094 2.3 8.328 2.3 11.429 0 40-21.347 40-44.244",
    style: {
      fill: "url(#b)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.003 2.981c7.692 0 23.148 3.889 32.434 6.432.867.238 1.681.468 2.43.685 3.088.895 5.136 3.751 5.136 6.966v4.728c-.917 21.064-7.667 27.191-26.507 42.361-2.475 2.19-5.018 4.272-7.599 6.387-3.7 3.03-7.479 6.125-11.249 9.692a7.478 7.478 0 0 0 2.537 12.439 22 22 0 0 1-2.182-.615c-6.89-2.31-16.191-8.601-23.474-16.956-5.741-35.774 5.512-53.308 28.474-72.119",
    style: {
      fill: "url(#c)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.003 2.981c7.692 0 23.148 3.889 32.434 6.432.867.238 1.681.468 2.43.685 3.088.895 5.136 3.751 5.136 6.966v4.728c-.917 21.064-7.667 27.191-26.507 42.361-2.475 2.19-5.018 4.272-7.599 6.387-3.7 3.03-7.479 6.125-11.249 9.692a7.478 7.478 0 0 0 2.537 12.439 22 22 0 0 1-2.182-.615c-6.89-2.31-16.191-8.601-23.474-16.956-5.741-35.774 5.512-53.308 28.474-72.119",
    style: {
      fill: "url(#d)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.003 2.981c7.692 0 23.148 3.889 32.434 6.432.867.238 1.681.468 2.43.685 3.088.895 5.136 3.751 5.136 6.966v4.728c-.917 21.064-7.667 27.191-26.507 42.361-2.475 2.19-5.018 4.272-7.599 6.387-3.7 3.03-7.479 6.125-11.249 9.692a7.478 7.478 0 0 0 2.537 12.439 22 22 0 0 1-2.182-.615c-6.89-2.31-16.191-8.601-23.474-16.956-5.741-35.774 5.512-53.308 28.474-72.119",
    style: {
      fill: "url(#e)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.003 2.981c7.692 0 23.148 3.889 32.434 6.432.867.238 1.681.468 2.43.685 3.088.895 5.136 3.751 5.136 6.966v4.728c-.917 21.064-7.667 27.191-26.507 42.361-2.475 2.19-5.018 4.272-7.599 6.387-3.7 3.03-7.479 6.125-11.249 9.692a7.478 7.478 0 0 0 2.537 12.439 22 22 0 0 1-2.182-.615c-6.89-2.31-16.191-8.601-23.474-16.956-5.741-35.774 5.512-53.308 28.474-72.119",
    style: {
      fill: "url(#f)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.355 10.026c8.831-2.471 26.306-7.045 34.648-7.045.6 0 1.249.024 1.937.07 7.626.736 13.587 7.162 13.587 14.981 0 2.839-.786 5.494-2.152 7.76-2.92 5.819-7.7 10.393-14.974 16.381-2.089 1.72-4.485 3.619-6.873 5.512a521 521 0 0 0-6.488 5.196c-4.808 3.942-7.747 6.352-9.363 9.376a15 15 0 0 0-2.433 8.208c0 4.433 1.916 8.419 4.966 11.173q.145.163.294.318l.079.119a70 70 0 0 1-2.866-2.593c-8.571-8.199-15.714-19.26-15.714-30.708V17.141c0-3.312 2.162-6.222 5.352-7.115",
    style: {
      fill: "url(#g)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.355 10.026c8.831-2.471 26.306-7.045 34.648-7.045.6 0 1.249.024 1.937.07 7.626.736 13.587 7.162 13.587 14.981 0 2.839-.786 5.494-2.152 7.76-2.92 5.819-7.7 10.393-14.974 16.381-2.089 1.72-4.485 3.619-6.873 5.512a521 521 0 0 0-6.488 5.196c-4.808 3.942-7.747 6.352-9.363 9.376a15 15 0 0 0-2.433 8.208c0 4.433 1.916 8.419 4.966 11.173q.145.163.294.318l.079.119a70 70 0 0 1-2.866-2.593c-8.571-8.199-15.714-19.26-15.714-30.708V17.141c0-3.312 2.162-6.222 5.352-7.115",
    style: {
      fill: "url(#h)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.355 10.026c8.831-2.471 26.306-7.045 34.648-7.045.6 0 1.249.024 1.937.07 7.626.736 13.587 7.162 13.587 14.981 0 2.839-.786 5.494-2.152 7.76-2.92 5.819-7.7 10.393-14.974 16.381-2.089 1.72-4.485 3.619-6.873 5.512a521 521 0 0 0-6.488 5.196c-4.808 3.942-7.747 6.352-9.363 9.376a15 15 0 0 0-2.433 8.208c0 4.433 1.916 8.419 4.966 11.173q.145.163.294.318l.079.119a70 70 0 0 1-2.866-2.593c-8.571-8.199-15.714-19.26-15.714-30.708V17.141c0-3.312 2.162-6.222 5.352-7.115",
    style: {
      fill: "url(#i)",
      fillRule: "nonzero"
    },
    transform: "translate(-8.003 -2.98)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(50.288 -33.238 85.948)scale(47.3395 141.5251)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003375",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#003375",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#003375",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003375",
      stopOpacity: 0.06
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(119.584 51.563 15.636)scale(151.2764 97.2376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23c0fe",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#23c0fe",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#1c91ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1c91ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(43.382 -21.54 65.642)scale(25.189 44.8208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1b44b1",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#1b44b1",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#045ed1",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(28.894 -61.893 175.5)scale(56.7755 83.2193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#045ed1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#045ed1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#1b44b1",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1b44b1",
      stopOpacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(248.903 37.844 -5.348)scale(91.964 70.2953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11a7ff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#11a7ff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#6ab3ff",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6ab3ff",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(126.614 32.088 15.326)scale(110.394 123.275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92eefe",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#35ddff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#15bdfb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#08b1f9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#08b1f9",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-87.723 29.193 -13.868)scale(86.6628 45.9894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92deff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#92deff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#92deff",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92deff",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(141.289 33.804 37.915)scale(68.0925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#143de0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#143de0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#003375",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003375",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.927 34.39)scale(-29.924)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22cbfd",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#22cbfd",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#92deff",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92deff",
      stopOpacity: 0.8
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefender);
export default __webpack_public_path__ + "static/media/Defender.d112f3b596838e4f1fee612680fbb880.svg";
export { ForwardRef as ReactComponent };